import graphqlClient from "../../../apollo";

class CompanyProvider {

    findCompany(id) {
        return graphqlClient.query({
            query: require('./gql/companyFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchCompanies() {
        return graphqlClient.query({
            query: require('./gql/companyFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateCompanies(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/companyPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    createCompany(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/companyCreate.graphql'),
            variables: { input: form },
            refetchQueries: [{ query: require('./gql/companyFetch.graphql') }]
        })
    }

    updateCompany(form) {
        const { id, ...input } = form;
        return graphqlClient.mutate({
            mutation: require('./gql/companyUpdate.graphql'),
            variables: { id, input },
            refetchQueries: [{ query: require('./gql/companyFetch.graphql') }]
        })
    }

    toggleActiveCompany(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/companyToggleActive.graphql'),
            variables: { id },
            refetchQueries: [{ query: require('./gql/companyFetch.graphql') }]
        })
    }

}

export default new CompanyProvider()

